import React, { FC, useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useCookies } from 'react-cookie';
import CompanyCard from './CompanyCard';
import { ICompany } from './interfaces';
import Modal from 'ui/Modal';
import Button from 'ui/Button';
import { css } from 'utils/helper';
import { useBlacklistRequests } from 'api/requests';
import { BlacklistActions } from 'redux/actionCreators/blacklistActions';

interface ICompaniesList {
  companies: ICompany[] | [];
  currentCompany: ICompany[] | [];
  setCurrentCompanyId: (state: number) => void;
  isFilterActive: boolean;
  isSearchActive: boolean;
}

const CompaniesList: FC<ICompaniesList> = ({
  companies,
  currentCompany,
  setCurrentCompanyId,
  isFilterActive,
  isSearchActive,
}: ICompaniesList) => {
  const dispatch = useDispatch();
  // @ts-ignore
  const { filteredCompanies } = useSelector((state) => state.blacklistReducer);
  const { removeCompany } = useBlacklistRequests();
  const [{ user }] = useCookies(['user']);
  const [isModalOpened, setIsModalOpened] = useState<boolean>(false);
  const [companyToRemoveId, setCompanyToRemoveId] = useState<number | null>(null);

  const removeCompanyHandler = async (companyId: number | null) => {
    if (!companyId) return;
    const response = await removeCompany(companyId);
    if (response.status === 200) {
      dispatch(BlacklistActions.removeCompany(companyId));
    }
    setIsModalOpened(false);
  };

  const renderCompaniesElements = (sourceArray: ICompany[] | []) => {
    return sourceArray.map((item: ICompany, index: number) => {
      return (
        <CompanyCard
          key={`${item.id}_${index}`}
          props={item}
          isAdmin={user?.isAdmin ?? false}
          setCompanyToRemoveId={setCompanyToRemoveId}
        />
      );
    });
  };

  useEffect(() => {
    if (companyToRemoveId !== null) {
      setIsModalOpened(true);
    }
  }, [companyToRemoveId]);

  return (
    <>
      <ul className="blacklist__companies-list">
        {currentCompany.length ? (
          renderCompaniesElements(currentCompany)
        ) : filteredCompanies.length ? (
          renderCompaniesElements(filteredCompanies)
        ) : !filteredCompanies.length && isFilterActive ? (
          <p className="blacklist__companies-list-notification">
            No results for the selected parameters. Please change the filter options.
          </p>
        ) : !filteredCompanies.length && isSearchActive ? (
          <p className="blacklist__companies-list-notification">
            No results found.
          </p>
          ) : (
          renderCompaniesElements(companies)
        )}
      </ul>
      {currentCompany.length ? (
        <Button
          name="remove"
          action={() => {
            setCurrentCompanyId(0);
            navigator.clipboard.writeText('');
            location.href = '/resources/blacklist';
          }}
          stylePreset="dark"
          customStyle={{ width: '200px' }}
        >
          Back to full list
        </Button>
      ) : (
        <></>
      )}

      <Modal
        size="medium"
        title="Remove item?"
        text=""
        modalHandler={() => setIsModalOpened(false)}
        open={isModalOpened}
        setModalVisible={setIsModalOpened}
        noIcon
        noRedirection
      >
        <div className="modal__buttons">
          <Button
            name="cancel"
            action={() => {
              setIsModalOpened(false);
              css(document.body, { overflow: 'visible' });
            }}
            stylePreset="bordered"
            customStyle={{ width: '170px', marginRight: '15px' }}
          >
            Cancel
          </Button>
          <Button
            name="remove"
            action={() => {
              removeCompanyHandler(companyToRemoveId);
              setIsModalOpened(false);
            }}
            stylePreset="dark"
            customStyle={{ width: '170px' }}
          >
            Remove
          </Button>
        </div>
      </Modal>
    </>
  );
};

export default CompaniesList;
